/* Footer collapsible menus on mobile, matching the inspiration store's behaviour. */
(function () {
  var MOBILE = '(max-width: 750px)';

  function initFooterAccordions() {
    var footer = document.querySelector('.footer');
    if (!footer) return;

    var headings = footer.querySelectorAll('.footer-block__heading');
    headings.forEach(function (heading) {
      var content =
        heading.parentElement.querySelector('.footer-block__details-content') ||
        heading.parentElement.querySelector('.main-brand') ||
        heading.nextElementSibling;
      if (!content) return;
      if (heading.dataset.cedBound === 'true') return;

      heading.classList.add('ced-accordion');
      content.classList.add('ced-accordion-content');
      heading.dataset.cedBound = 'true';

      heading.addEventListener('click', function () {
        if (!window.matchMedia(MOBILE).matches) return;
        heading.classList.toggle('active');
        content.classList.toggle('active2');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooterAccordions);
  } else {
    initFooterAccordions();
  }

  document.addEventListener('shopify:section:load', initFooterAccordions);
})();
